import React from 'react';
import { withTheme, withStyles, alpha, makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { scaleSequential } from 'd3-scale';
import { extent } from 'd3-array';
import { interpolateBlues } from 'd3-scale-chromatic';
import moment from 'moment';
import numeral from 'numeral';
import { capitalCase } from 'change-case';
import { Group } from '@visx/group';
import { stratify, hierarchy, Treemap, treemapSquarify } from '@visx/hierarchy';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Alert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import PublicIcon from '@material-ui/icons/Public';
import Typography from '@material-ui/core/Typography';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { alpha as alpha$1, Paper as Paper$1, Typography as Typography$1 } from '@material-ui/core';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles$2 = function
  /* theme */
styles() {
  return {
    pointerText: {
      pointerEvents: 'none'
    }
  };
};

var NewPlacesTree = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NewPlacesTree, _React$PureComponent);

  var _super = _createSuper(NewPlacesTree);

  function NewPlacesTree(props) {
    var _this;

    _classCallCheck(this, NewPlacesTree);

    _this = _super.call(this, props); // prettier-ignore

    _this.widths = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625];
    _this.avg = 0.5293256578947368;
    return _this;
  } // topic label rendering helpers


  _createClass(NewPlacesTree, [{
    key: "topicLabel",
    value: function topicLabel(topic, nodeWidth, nodeHeight, tspanList) {
      var extent = Math.floor(nodeWidth / 8.25);
      var approxPixels = this.measureText(topic);
      var len = topic.trim().length;

      if (len === 0) {
        return tspanList;
      }

      if (len <= extent || approxPixels <= nodeWidth) {
        tspanList.push(topic);
        return tspanList;
      } else if (nodeHeight < 20) {
        var popped = tspanList.pop();
        tspanList.push("".concat(popped, "..."));
        return tspanList;
      } else {
        var idx = this.getNearestSpaceIdx(topic, extent);
        var spaceIdx = topic.indexOf(' ');
        var substring = topic.substring(0, idx > 0 ? idx : extent);
        var substringSpace = topic.substring(0, spaceIdx > 0 ? spaceIdx : extent);

        if (this.measureText(substringSpace) <= nodeWidth) {
          substring = substringSpace;
          idx = spaceIdx;
        }

        var postSub = topic.substring(idx > 0 ? idx + 1 : extent);

        if (postSub.length === 1 || this.measureText(postSub) <= nodeWidth - this.measureText(substring)) {
          tspanList.push(topic);
          return tspanList;
        } else {
          tspanList.push(substring);
          return this.topicLabel(postSub, nodeWidth, nodeHeight - 17, tspanList);
        }
      }
    }
  }, {
    key: "getNearestSpaceIdx",
    value: function getNearestSpaceIdx(str, extent) {
      var nearestSpaceIdx = -1;

      for (var i = 0; i < extent + 2; i++) {
        if (str[i] === ' ') {
          nearestSpaceIdx = i;
        }
      }

      return nearestSpaceIdx;
    }
  }, {
    key: "renderTspans",
    value: function renderTspans(topic, nodeWidth, nodeHeight) {
      var arr = this.topicLabel(topic, nodeWidth, nodeHeight, []);
      return arr.map(function (t, i) {
        return /*#__PURE__*/React.createElement("tspan", {
          key: "".concat(topic, "-").concat(nodeWidth, "-").concat(nodeHeight, "-").concat(i, "-").concat(t),
          x: "1",
          dy: "0.85em"
        }, t);
      });
    } // from https://bl.ocks.org/tophtucker/raw/62f93a4658387bb61e4510c37e2e97cf/?raw=true

  }, {
    key: "measureText",
    value: function measureText(string) {
      var _this2 = this;

      var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
      return string.split('').map(function (c) {
        return c.charCodeAt(0) < _this2.widths.length ? _this2.widths[c.charCodeAt(0)] : _this2.avg;
      }).reduce(function (cur, acc) {
        return acc + cur;
      }) * fontSize;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          theme = _this$props.theme,
          classes = _this$props.classes,
          data = _this$props.data,
          width = _this$props.width,
          height = _this$props.height,
          cacheAge = _this$props.cacheAge,
          dataKey = _this$props.dataKey;
      if (!data || width < 10 || height < 10) return null;
      var treeD = [{
        id: 'Places',
        parent: null,
        size: 0
      }];
      var treeV = [];

      for (var _i = 0, _Object$entries = Object.entries(data[dataKey]); _i < _Object$entries.length; _i++) {
        var kvp = _Object$entries[_i];
        var id = kvp[0];
        var v = kvp[1];
        treeV.push(v);
        treeD.push({
          id: id,
          parent: 'Places',
          size: Math.abs(v),
          value: v
        });
      }

      var treeDS = stratify().id(function (d) {
        return d.id;
      }).parentId(function (d) {
        return d.parent;
      })(treeD).sum(function (d) {
        return d.size || 0;
      });
      var treeRoot = hierarchy(treeDS).sort(function (a, b) {
        var _b$value, _a$value;

        return ((_b$value = b.value) !== null && _b$value !== void 0 ? _b$value : 0) - ((_a$value = a.value) !== null && _a$value !== void 0 ? _a$value : 0);
      });
      var treeColorScale = scaleSequential().domain(extent(treeV)).interpolator(interpolateBlues);
      var maxDateFormatted = moment(cacheAge).format('ha on MMM Do');
      if (!treeRoot) return null;
      return /*#__PURE__*/React.createElement("svg", {
        height: height,
        width: width
      }, /*#__PURE__*/React.createElement(Treemap, {
        root: treeRoot,
        size: [width, height],
        tile: treemapSquarify,
        round: true
      }, function (treemap) {
        return /*#__PURE__*/React.createElement(Group, null, treemap.descendants().reverse().map(function (node) {
          var _node$depth;

          var nodeWidth = node.x1 - node.x0;
          var nodeHeight = node.y1 - node.y0;
          return /*#__PURE__*/React.createElement(Group, {
            key: "".concat(node.data.data.id, "-").concat((_node$depth = node.depth) !== null && _node$depth !== void 0 ? _node$depth : 0),
            top: node.y0,
            left: node.x0
          }, node.depth === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
            width: nodeWidth,
            height: nodeHeight,
            stroke: theme.palette.background.paper,
            strokeWidth: 1,
            fill: treeColorScale(node.data.data.value)
          }, /*#__PURE__*/React.createElement("title", null, "".concat(capitalCase(node.data.data.id), ": ").concat(numeral(node.data.data.value).format(','), " as of ").concat(maxDateFormatted))), nodeHeight >= 45 && nodeWidth >= 45 && /*#__PURE__*/React.createElement("text", {
            x: nodeWidth,
            y: nodeHeight - 5,
            textAnchor: "end",
            alignmentBaseline: "middle",
            fill: theme.palette.getContrastText(treeColorScale(node.data.data.value)),
            fontSize: theme.typography.body2.fontSize,
            fontFamily: theme.typography.fontFamily,
            className: classes.pointerText
          }, numeral(node.data.data.value).format('0')), nodeHeight >= 45 && nodeWidth >= 45 && /*#__PURE__*/React.createElement("text", {
            x: "1",
            y: "2" // width={Math.max(0, nodeWidth - 8)}
            // height={Math.max(0, nodeHeight - 8)}
            ,
            textAnchor: "start",
            alignmentBaseline: "hanging",
            fill: theme.palette.getContrastText(treeColorScale(node.data.data.value)),
            fontSize: theme.typography.body2.fontSize,
            fontFamily: theme.typography.fontFamily,
            className: classes.pointerText
          }, _this3.renderTspans(capitalCase(node.data.data.id), nodeWidth, nodeHeight))));
        }));
      }));
    }
  }]);

  return NewPlacesTree;
}(React.PureComponent);

NewPlacesTree.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  cacheAge: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  dataKey: PropTypes.string
};
NewPlacesTree.defaultProps = {
  dataKey: 'new'
};
var NewPlacesTree$1 = withTheme(withStyles(styles$2)(NewPlacesTree));

var styles$1 = function styles() {
  return {
    iconButton: {
      marginLeft: 12
    }
  };
};

var Notification = /*#__PURE__*/function (_React$Component) {
  _inherits(Notification, _React$Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this, props);
    _this.state = {
      timeout: null
    };
    _this.onManualClose = _this.onManualClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.timeout) {
        clearTimeout(this.state.timeout);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props = this.props,
          popSnackbar = _this$props.popSnackbar,
          q = _this$props.notificationQueue;
      var timeout = this.state.timeout;

      if (q.length > 0 && !timeout) {
        var t = setTimeout(function () {
          popSnackbar();

          _this2.setState({
            timeout: null
          });
        }, 6000);
        this.setState({
          timeout: t
        });
      }
    }
  }, {
    key: "onManualClose",
    value: function onManualClose() {
      this.props.popSnackbar();
      clearTimeout(this.state.timeout);
      this.setState({
        timeout: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _notification$type;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          notificationQueue = _this$props2.notificationQueue;

      if (!notificationQueue || notificationQueue.length === 0) {
        return null;
      }

      var _notificationQueue = _slicedToArray(notificationQueue, 1),
          notification = _notificationQueue[0];

      return /*#__PURE__*/React.createElement(Snackbar, {
        open: true
      }, /*#__PURE__*/React.createElement(Alert, {
        elevation: 6,
        variant: "filled",
        severity: (_notification$type = notification.type) !== null && _notification$type !== void 0 ? _notification$type : 'info'
      }, "".concat(notificationQueue.length > 1 ? "(".concat(notificationQueue.length - 1, " more...) ") : '').concat(notification.message), /*#__PURE__*/React.createElement(IconButton, {
        className: classes.iconButton,
        size: "small",
        color: "inherit",
        onClick: this.onManualClose
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        fontSize: "small"
      }))));
    }
  }]);

  return Notification;
}(React.Component);

Notification.propTypes = {
  // Material UI
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  notificationQueue: PropTypes.array.isRequired,
  popSnackbar: PropTypes.func.isRequired
};
Notification.defaultProps = {};
var Notification$1 = withTheme(withStyles(styles$1)(Notification));

var styles = function styles(theme) {
  return {
    paper: {
      width: '100%',
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
      zIndex: 0,
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',
      border: '1px solid',
      borderColor: theme.palette.background.paper
    },
    paperHover: {
      '&:hover': {
        border: '1px solid',
        borderColor: theme.palette.secondary.main,
        backgroundColor: alpha(theme.palette.secondary.dark, 0.1)
      }
    },
    paperSelected: {
      backgroundColor: alpha(theme.palette.secondary.main, 0.4),
      border: '1px solid',
      borderColor: theme.palette.secondary.main
    },
    fullWidth: {
      flexBasis: '100%',
      width: '100%'
    },
    gridContainer: {
      flexFlow: 'row wrap',
      display: 'flex',
      '& > *': {
        display: 'flex'
      }
    },
    locationContainer: {
      width: '100%',
      flexBasis: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    question: {
      textAlign: 'justify'
    },
    alertContainer: {
      justifyContent: 'flex-end'
    }
  };
};

var SentimentAlertPaper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SentimentAlertPaper, _React$PureComponent);

  var _super = _createSuper(SentimentAlertPaper);

  function SentimentAlertPaper(props) {
    var _this;

    _classCallCheck(this, SentimentAlertPaper);

    _this = _super.call(this, props);
    _this.state = {}; // BiND

    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.icons = [NotificationsNoneIcon, NotificationsIcon, NotificationsActiveIcon];
    return _this;
  }

  _createClass(SentimentAlertPaper, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
          active = _this$props.active,
          onClick = _this$props.onClick,
          alert = _this$props.alert;
      if (!active) onClick(alert);
    }
  }, {
    key: "render",
    value: function render() {
      var _alert$num_alerts;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          alert = _this$props2.alert,
          style = _this$props2.style,
          active = _this$props2.active;
      var iconIndex = alert.iconIndex;
      var Icon = this.icons[iconIndex];
      return /*#__PURE__*/React.createElement(Paper, {
        id: alert.form_id,
        className: clsx(classes.paper, 'noselect', active ? classes.paperSelected : classes.paperHover),
        style: _objectSpread2(_objectSpread2({}, style), {}, {
          height: 128
        }),
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignContent: "flex-start",
        justifyContent: "flex-start"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridContainer
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 10,
        className: classes.fullWidth,
        variant: "subtitle1"
      }, alert.form_name), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2,
        className: classes.alertContainer
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2"
      }, (_alert$num_alerts = alert.num_alerts) !== null && _alert$num_alerts !== void 0 ? _alert$num_alerts : 0), /*#__PURE__*/React.createElement(Icon, {
        fontSize: 'small',
        style: {
          marginLeft: theme.spacing(0.5)
        }
      })), /*#__PURE__*/React.createElement(Box, {
        className: classes.locationContainer
      }, /*#__PURE__*/React.createElement(PublicIcon, {
        style: {
          marginRight: theme.spacing(0.5)
        }
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        noWrap: true
      }, alert.hasc_proper)), /*#__PURE__*/React.createElement(Typography, {
        className: classes.question,
        variant: "body2"
      }, alert.question_proper))));
    }
  }]);

  return SentimentAlertPaper;
}(React.PureComponent);

SentimentAlertPaper.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  active: PropTypes.bool
};
SentimentAlertPaper.defaultProps = {
  active: false,
  style: {}
};
var SentimentAlertPaper$1 = withTheme(withStyles(styles)(SentimentAlertPaper));

var useStyles = makeStyles(function (theme) {
  return {
    paper: {
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',
      border: '1px solid',
      borderColor: theme.palette.background.paper
    },
    paperHover: {
      '&:hover': {
        border: '1px solid',
        borderColor: theme.palette.secondary.main,
        backgroundColor: alpha$1(theme.palette.secondary.dark, 0.1)
      }
    },
    paperSelected: {
      backgroundColor: alpha$1(theme.palette.secondary.main, 0.4),
      border: '1px solid',
      borderColor: theme.palette.secondary.main
    },
    topBorder: {
      width: '100%',
      height: '10px',
      borderRadius: '4px 4px 0px 0px'
    },
    paperContent: {
      padding: theme.spacing(1)
    }
  };
});

function DemographicResultsPaper(_ref) {
  var name = _ref.name,
      count = _ref.count,
      color = _ref.color,
      active = _ref.active,
      population = _ref.population,
      style = _ref.style,
      onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Paper$1, {
    className: clsx(classes.paper, 'noselect', active ? classes.paperSelected : classes.paperHover),
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      height: 95
    }),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.topBorder,
    style: color && {
      backgroundColor: "".concat(color)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.paperContent
  }, /*#__PURE__*/React.createElement(Typography$1, {
    noWrap: true
  }, name), /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, numeral(count).format(','), " ", count > 1 ? 'respondents' : 'respondent'), /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, population ? "Total population of ".concat(numeral(population).format(',')) : 'Population data not found')));
}

DemographicResultsPaper.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  color: PropTypes.string,
  population: PropTypes.number,
  active: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func
};
DemographicResultsPaper.defaultProps = {
  active: false,
  style: {}
};
var DemographicResultsPaper$1 = /*#__PURE__*/React.memo(DemographicResultsPaper);

export { DemographicResultsPaper$1 as DemographicResultsPaper, NewPlacesTree$1 as NewPlacesTree, Notification$1 as Notification, SentimentAlertPaper$1 as SentimentAlertPaper };
